const responsiveImages = require.context('./responsive', false, /\.webp$/);

const imageUrl = (filename) => responsiveImages(`./${filename}`);

const gallerySourceWidths = {
  'slideshow-01': 1900,
  'slideshow-009': 1890,
  'slideshow-011': 1890,
  'slideshow-030': 1890,
};

export const getGalleryImageSources = (name) => ({
  thumbnail: imageUrl(`${name}-480.webp`),
  medium: imageUrl(`${name}-960.webp`),
  mediumLarge: imageUrl(`${name}-1280.webp`),
  desktop: imageUrl(`${name}-1600.webp`),
  large: imageUrl(`${name}-2000.webp`),
  largeWidth: gallerySourceWidths[name] || 2000,
});

export const heroSources = {
  small: imageUrl('hero-640.webp'),
  medium: imageUrl('hero-1280.webp'),
  desktop: imageUrl('hero-1600.webp'),
  large: imageUrl('hero-2000.webp'),
};

export const footerSources = {
  small: imageUrl('footer-640.webp'),
  medium: imageUrl('footer-1280.webp'),
  desktop: imageUrl('footer-1600.webp'),
  large: imageUrl('footer-1920.webp'),
};

export const stripeSources = {
  small: imageUrl('stripe-640.webp'),
  medium: imageUrl('stripe-1280.webp'),
  desktop: imageUrl('stripe-1600.webp'),
  large: imageUrl('stripe-1900.webp'),
};

export const merchandiseSources = {
  small: imageUrl('merchandise-540.webp'),
  large: imageUrl('merchandise-1086.webp'),
};

export const albumSources = {
  album01: {
    small: imageUrl('album-01-360.webp'),
    large: imageUrl('album-01-720.webp'),
    largeWidth: 720,
  },
  album02: {
    small: imageUrl('album-02-360.webp'),
    large: imageUrl('album-02-720.webp'),
    largeWidth: 720,
  },
  album03: {
    small: imageUrl('album-03-360.webp'),
    large: imageUrl('album-03-600.webp'),
    largeWidth: 600,
  },
};
